// libs
import get from 'lodash/get';

// helpers
import storage from 'shared/helpers/storage';

// type
import { PincodeApiResponse } from 'shared/layouts/DetailsPage/components/ProductInfo/types';

// constants
export const STORAGE_KEY_PINCODE = 'NFFE_PINCODE';

export const getPinCodeDataFromStorage = () => {
  try {
    const pincodeResponseData = storage.getItem(STORAGE_KEY_PINCODE) || {};
    if (typeof pincodeResponseData === 'string') return JSON.parse(pincodeResponseData);
    else return pincodeResponseData;
  } catch (err) {
    return {};
  }
};

export const setPinCodeToStorage = (value: {
  response: PincodeApiResponse;
  status: string;
  pincode: string;
}) => {
  storage.setItem(STORAGE_KEY_PINCODE, value);
};

export const EDIT_TEXT = 'Edit';
export const DEFAULT_TITLE = 'Select Delivery Location';
export const BUTTON_TEXT = 'Apply';
export const DELIVERY_HEADING = 'Select Delivery Location';
export const DELIVERY_TEXT =
  'Enter the pincode of your area to check product availability and delivery options';

export const getPinCodeLabel = (pinCodeResponse: PincodeApiResponse) => {
  const city = get(pinCodeResponse, 'city', '');
  const pincode = get(pinCodeResponse, 'pincode', '');

  return `Delivers to ${city} - ${pincode}`;
};

export const getPinCodeLabelV1 = (pinCodeResponse: PincodeApiResponse) => {
  const city = get(pinCodeResponse, 'response.city', '');
  const pincode = get(pinCodeResponse, 'pincode', '');

  return `Delivers to ${city} - ${pincode}`;
};
